/* esm.sh - applesauce-core@5.2.0/helpers/cache */
export * from "/*applesauce-core@5.2.0/esnext/helpers/cache.mjs";
